import {removeDesktopGuideLayer} from "./render"

const {isKey} = Mutil;

function addGuideLayerEvent() {
    const $desktopGuideLayer = $("#desktopGuideLayer");
    $desktopGuideLayer.off("mousedown").on("mousedown", (e) => e.stopPropagation());
    $desktopGuideLayer.find(".js-close-btn").off("click").on("click", removeDesktopGuideLayer);
    $desktopGuideLayer.find("#desktopDownload").off("click").on("click", desktopDownload);
    $desktopGuideLayer.off("keydown").on("keydown", keyDownDesktopLayer)
}

function desktopDownload() {
    var os = userOsCheck();
    var pckNm = "team.flow.flowMiniRenewal";
    const isDirect = !Mutil.exist(window._USER_ID);

    if(Often.isFunc(Func.CLOUD.SECURE_CONNECT) || Often.isFunc("MINI_SECURE_DOWNLOAD")) pckNm = "secure.team.flow.flowMiniRenewal";
    if(Often.isFunc(Func.CLOUD.MINI_DIRECTORY_DOWNLOAD)) pckNm = "dir.team.flow.flowMiniRenewal";
    if(Often.null2Void(_ENTER_YN, "N") === "Y") pckNm = "team.flow.flowEntMini";
    if(Often.isGlobal()) pckNm = "com.morningmate.flowMiniRenewal";
    var downloadData = {PCK_NM: pckNm, GB: os}
    isDirect && (downloadData.RGSN_DTTM = "NO-SESSION");
    Ajax.executeApi(RestApi.GET.FLOW_UPDATE_R001, downloadData,  updateSuccessCallback);

    function userOsCheck() {
        var os = "";
        var ua = navigator.userAgent;

        if (ua.indexOf("Macintosh") > -1) {
            os = "OS_X";
        } else if (ua.indexOf("Linux") > -1) {
            os = "LINUX";
        } else {
            os = "WINDOWS";
        }
        return os;
    }

    function updateSuccessCallback(dat) {
        if (Often.null2Void(dat.flow_rec[0], "") === "") return;
        if (ElectronApi.Comm.isElectronApp()) {
            ElectronApi.Download.download(dat.flow_rec[0].LINK_URL, '_blank');
        } else {
            window.open(dat.flow_rec[0].LINK_URL, '_blank');
        }
    }
}

function keyDownDesktopLayer(e) {
    e.stopPropagation();
    if(isKey(e, "ESC")) return removeDesktopGuideLayer();
}

export {addGuideLayerEvent}
